import { UploadCampaignCsvField } from './UploadCampaignCsvField'
import { withUploadCampaignCsvField } from './withUploadCampaignCsvField'

const Connected = withUploadCampaignCsvField(UploadCampaignCsvField)

export { Connected as UploadCampaignCsvField }
